import React from 'react'
import { NumericFormat } from 'react-number-format'

const Amount = ({ value }: { value: number | undefined }) => {
  return (
    <NumericFormat
      value={value}
      displayType={'text'}
      thousandSeparator={true}
      prefix={'$'}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  )
}

export default Amount
